import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PERGUNTAS = [
  'Vai cobrar alguma coisa?',
  'Vai ter ficha de inscrição com vagas?',
  'Vai ter ação entre amigos?',
];

function destinoDasRespostas(respostas: boolean[]): string {
  const [cobra, ficha, sorteio] = respostas;
  if (sorteio) return '/criar/sorteio';
  if (cobra && ficha) return '/criar/inscricoes';
  if (cobra) return '/criar/ingresso';
  return '/criar/divulgar';
}

export default function CriarOutroPage() {
  const navigate = useNavigate();
  const [respostas, setRespostas] = useState<boolean[]>([]);
  const [entendido, setEntendido] = useState(false);

  const indice = respostas.length;

  function responder(sim: boolean) {
    if (entendido) return;
    const novas = [...respostas, sim];
    setRespostas(novas);
    if (novas.length === PERGUNTAS.length) {
      setEntendido(true);
      const destino = destinoDasRespostas(novas);
      window.setTimeout(() => navigate(destino, { replace: true }), 1000);
    }
  }

  return (
    <div className="min-h-screen bg-background-100">
      <header className="sticky top-0 z-20 border-b border-secondary-200 bg-white">
        <div className="mx-auto flex h-16 w-full max-w-[720px] items-center px-4 md:px-6">
          <Link
            to="/criar"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-foreground-950"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-arrow-left-line" />
            </span>
            Voltar
          </Link>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[720px] px-4 py-8 md:px-6">
        {entendido ? (
          <div className="flex min-h-[40vh] flex-col items-center justify-center text-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-check-line text-3xl" />
            </span>
            <p className="mt-5 text-lg font-medium text-foreground-950">
              Entendi. Vamos montar isso para você.
            </p>
          </div>
        ) : (
          <>
            <h1 className="text-[28px] font-normal text-foreground-950">
              Conta pra gente o que você precisa
            </h1>
            <p className="mt-1 text-sm text-secondary-500">
              Três perguntinhas e a gente aponta o melhor caminho.
            </p>

            <div className="mt-6">
              <p className="text-sm font-medium text-secondary-500">
                Pergunta {indice + 1} de {PERGUNTAS.length}
              </p>

              <div className="mt-2 overflow-hidden rounded-2xl border border-[#E7E3EF] bg-white shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
                <div className="h-[10px] w-full bg-primary-500" />
                <div className="p-6">
                  <h2 className="text-base font-medium text-foreground-950">
                    {PERGUNTAS[indice]}
                  </h2>
                  <div className="mt-5 grid grid-cols-2 gap-3">
                    <button
                      type="button"
                      onClick={() => responder(true)}
                      className="cursor-pointer whitespace-nowrap rounded-lg border border-secondary-200 bg-white py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:bg-primary-50"
                    >
                      Sim
                    </button>
                    <button
                      type="button"
                      onClick={() => responder(false)}
                      className="cursor-pointer whitespace-nowrap rounded-lg border border-secondary-200 bg-white py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:bg-primary-50"
                    >
                      Não
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </main>
    </div>
  );
}